import { useRef } from "react";
import UpdateActivityDialog from "views/components/Schedules/components/UpdateActivityPopup";
import ReservationData from "../ReservationData/ReservationData";
import CheckIcon from "icons/CheckIcon";
import AttendedIcon from "icons/AttendedIcon";
import useLoadingRequest from "components/Preloader/utils/hooks/useLoadingRequest";
import Preloader from "components/Preloader/Preloader";
import DialogConfirmExitWithoutSaving from "./components/DialogConfirmExitWithoutSaving/DialogConfirmExitWithoutSaving";
import useUpdateActivityPopupWithExitConfirmation from "views/components/Schedules/components/UpdateActivityPopup/hooks/useUpdateActivityPopupWithExitConfirmation";
import LibraryScheduleActivityCard from "../LibraryScheduleActivityCard";

const ScheduleActivity = ({
    header, reservation,
    quantityCells = 4,
    classList = [],
    reloadData
}) => {
    const $activity = useRef();
    const { finalized } = reservation;
    const updateActivityPopup = useUpdateActivityPopupWithExitConfirmation({
        $activity
    });
    const loadingRequest = useLoadingRequest();
    const { dialogConfirmExitWithoutSaving } = updateActivityPopup;
    //#region Functions
    const hasReservationState = () => {
        return typeof finalized === "boolean";
    }
    const getNewClassList = () => {
        const newClassList = [];
        hasReservationState() && classList.push(finalized ? "finalized" : "on-use");
        return [...classList, ...newClassList];
    }
    const getIsManualReservation = () => {
        return classList.includes("manual");
    }
    function closeUpdateActivityDialog() {
        dialogConfirmExitWithoutSaving.hide();
        updateActivityPopup.popup.hide();
    }
    //#endregion
    return (
        <td rowSpan={quantityCells}>
            <UpdateActivityDialog
                updateActivityPopup={updateActivityPopup}
                confirmExitFromDialog={dialogConfirmExitWithoutSaving.open}
                mustConfirm={updateActivityPopup.mustConfirm.value}>
                {reservation &&
                    <ReservationData
                        loadingRequest={loadingRequest}
                        data={{
                            ...reservation,
                            isManual: getIsManualReservation(),
                            reloadData,
                            dialogShowUpdate: updateActivityPopup.popup
                        }}
                        updateActivityPopup={updateActivityPopup} />}
            </UpdateActivityDialog>
            {updateActivityPopup.popup.value && (
                <>
                    <Preloader {...loadingRequest.value} />
                    <DialogConfirmExitWithoutSaving
                        dialogShow={dialogConfirmExitWithoutSaving}
                        closeUpdateActivityDialog={closeUpdateActivityDialog} />
                </>
            )}
            <LibraryScheduleActivityCard
                classList={getNewClassList()}
                activity={$activity}
                quantityCells={quantityCells}
                header={header}
                icon={hasReservationState() && (
                    finalized
                        ? <CheckIcon className="icon" />
                        : <AttendedIcon className="icon" />
                )}
                dialogUpdate={updateActivityPopup.popup} />
        </td>
    );
}

export default ScheduleActivity;